import React from 'react';
import {
  Stack, ListItem, SxProps, Tooltip,
} from '@mui/material';
import {
  ListItemCardSubtitle,
  ListItemCardTitle,
  LinkCard,
  ZAvatar,
} from '@marageti/z4-lib';
import { Agent } from '@marageti/z4-sdk/lib/people';
import { getRoleDisplayName } from '../../utils/helpers';
import { peopleStatusIcons } from '../status-icons';
import { getMatchingUser } from '../../utils/auth';

type Props<T> = {
  loading?: boolean;
  individual: T;
  to: string;
  sx?: SxProps;
};

const UserLinkCard = <T extends Agent>({
  individual,
  loading = false,
  to,
  sx = {},
}: Props<T>) => {
  const userInfo = getMatchingUser(individual.email, individual.userInfo);
  return (
    <ListItem disablePadding sx={sx}>
      <LinkCard
        key={individual.id}
        to={to}
        state={individual}
        sx={{
          width: '100%',
        }}
      >
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Stack direction="row" spacing={1} gap={2}>
            <ZAvatar
              size={40}
              loading={loading}
              src={individual?.avatar}
              name={individual.fullName}
            />
            <Stack
              alignItems="space-between"
              minHeight="45px"
              sx={{ marginLeft: '16px' }}
            >
              <ListItemCardTitle>
                {`${individual.givenName} ${individual.familyName}`}
              </ListItemCardTitle>
              <ListItemCardSubtitle>
                {getRoleDisplayName(individual.userInfo![0].roles)}
              </ListItemCardSubtitle>
            </Stack>
          </Stack>
          {userInfo && (
            <Tooltip
              title={peopleStatusIcons[userInfo.status].displayName}
              placement="right"
            >
              <span>{peopleStatusIcons[userInfo.status].icon}</span>
            </Tooltip>
          )}
        </Stack>
      </LinkCard>
    </ListItem>
  );
};

export default UserLinkCard;
